import { Component, OnInit } from '@angular/core'
import { ResetPasswordFormComponent } from '../../../features/login/reset-password-form/reset-password-form.component'
import { Router } from '@angular/router'
import { AuthLayoutComponent } from '../../../shared/components/auth-layout/auth-layout.component'

@Component({
  selector: 'reset-password',
  imports: [ResetPasswordFormComponent, AuthLayoutComponent],
  templateUrl: './reset-password.component.html',
  standalone: true,
})
export class ResetPasswordComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    if (!document.URL.includes('token=')) {
      this.router.navigate(['/login'])
    }
  }
}
